@if (!events) {
  <motn-spinner [centered]="true"></motn-spinner>
}

@if (events) {
  <motn-sort-table
    [paginationManagedByParent]="true"
    [table$]="table$"
  ></motn-sort-table>
}
